@for (title of formattedOptions.keys(); track $index) {
  <div class="radio-group sorting-key">
    @if (title !== '') {
      <p class="light-bold">{{title | translate}}</p>
    }
    @for (item of formattedOptions.get(title); track $index) {
      <app-checkbox
        type="radio"
        [groupId]="groupId"
        [label]="item.label"
        [state]="getCurrentState(item)"
        (stateChange)="onStateChanged(item)"
      />
    }
  </div>
}
